import { IbexaColorPair } from '@/enums/IbexaColorPair'
import type { IbexaBaseItemFields, IbexaImageField, IbexaRelationField } from '@/types/Ibexa'

interface DrawerContent {
  title: string
  description: string
  imageUrl?: string
}

export enum TaskImageAlign {
  Landscape = '3/2',
  Portrait = '2/3',
  Stretch = 'stretch',
}

export interface StepTask extends IbexaBaseItemFields {
  imageAlign?: TaskImageAlign
  image?: IbexaImageField
  isNoAidTask?: boolean
  description: string
  rightColumnRichText?: string
  isStepSuperTitle?: boolean
  isNumberBullets?: boolean
  subtasks: string[]
  descriptionAfterSubtasks: string
  hint: string
  relatedResourceContentIds: number[]
  drawerContent?: DrawerContent //    TODO
  svg?: IbexaRelationField
  imageAlt?: string
  taskList?: []
}

export interface AnchorNavigationTask extends IbexaBaseItemFields {
  image?: IbexaImageField
  isNoAidTask?: boolean
  description: string
  subtasks: string[]
  descriptionAfterSubtasks: string
  svg?: IbexaRelationField
  imageAlt?: string
  rightColumnRichText?: string
}

export interface AssignmentSet {
  title: string,
  folderContentId: number,
  assignmentContentIds?: number[],
  image?: IbexaImageField
}

export interface TaskFrontpage extends IbexaBaseItemFields {
  colorPair?: IbexaColorPair
  description?: string
  image?: IbexaImageField
  svg?: IbexaRelationField
  imageAlt?: string
  imageCaption?: string
}
